import ServicesGasFlowOptimizer from "../../components/ServicesGasFlowOptimizer/ServicesGasFlowOptimizer";


function ServicesGasFlowOptimizerPage() {
  return <ServicesGasFlowOptimizer />;
}

export default ServicesGasFlowOptimizerPage;
